import React, { useMemo, useState, useEffect } from 'react';
import { func } from 'prop-types';
import { waypointPropTypes } from '../../../../proptypes/shared';
import { dateString } from '../../../../utils/time_helpers';
import Button from '../../Button';
import * as styles from './styles/styles.module.scss';
import OriginalLanguageButton from '../../OriginalLanguageButton';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const WaypointPopup = ({ waypoint, toggleShowTitle, addToVRoute, messagingChannel }) => {
  const [showTitle, updateShowTitle] = useState(waypoint.waypointDisplayProperty ? waypoint.waypointDisplayProperty.showTitle : false);
  const [vRouteLabel, updateVRouteLabel] = useState('Add To VRoute');
  const [isTranslated, toggleIsTranslated] = useState(true);
  const [location, updateLocation] = useState(waypoint.location);

  const handleWaypointDragged = data => {
    const {
      location: { latitude, longitude }
    } = data;

    const newLocation = {
      longitude: longitude.toFixed(5),
      latitude: latitude.toFixed(5)
    };

    updateLocation(newLocation);
  };

  useEffect(() => {
    if (!messagingChannel) {
      return;
    }

    messagingChannel.subscribe('waypoint.dragged.with_location', handleWaypointDragged);
  }, []);
  const coordinates = useMemo(() => {
    const { latitude, longitude } = location;

    return `${parseFloat(latitude).toFixed(5)}, ${parseFloat(longitude).toFixed(5)}`;
  }, [location]);

  const handleToggleShowTitle = () => {
    updateShowTitle(prevState => !prevState);
    toggleShowTitle();
  };

  const vRouteAddedOrFailed = () => {
    return vRouteLabel === 'Added' || vRouteLabel === 'Failed';
  };

  const handleAddtoVRoute = () => {
    if (vRouteAddedOrFailed()) {
      return;
    }

    addToVRoute()
      .then(text => {
        updateVRouteLabel(text);
      })
      .catch(text => {
        updateVRouteLabel(text);
      });
  };

  const [name, description] = useMemo(() => {
    if (waypoint.id === null) {
      return [StringConstantsMixin.strings.NEW_WAYPOINT, StringConstantsMixin.strings.DRAG_TO_DESIRED_LOCATION];
    }

    let wpName = isTranslated && waypoint.name_source && waypoint.name_source !== 'null' ? waypoint.name_source : waypoint.name;
    if (!wpName || wpName === 'null') {
      wpName = '';
    }
    let wpDescription =
      isTranslated && waypoint.description_source && waypoint.description_source !== 'null' ? waypoint.description_source : waypoint.description;
    if (!wpDescription || wpDescription === 'null') {
      wpDescription = '';
    }

    return [wpName, wpDescription];
  }, [waypoint, isTranslated]);

  return (
    <div className={styles.container}>
      <div className={styles.nameAndDescription}>
        <div className={styles.title}>{name}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.coordinates}>
        {waypoint.date && <div>{dateString(waypoint.date, waypoint.timezone)}</div>}
        <div>{coordinates}</div>
      </div>
      {waypoint.name && (
        <div className={styles.controlBtns}>
          <div>
            {toggleShowTitle && (
              <Button variant="flat" classes={styles.linkBtn} onClick={handleToggleShowTitle}>
                {showTitle ? StringConstantsMixin.strings.WAYPOINT_POPUP.HIDE_TITLE : StringConstantsMixin.strings.WAYPOINT_POPUP.SHOW_TITLE}
              </Button>
            )}
            {(addToVRoute || vRouteAddedOrFailed()) && (
              <Button variant="flat" classes={styles.linkBtn} onClick={handleAddtoVRoute} disabled={vRouteAddedOrFailed()}>
                {vRouteLabel}
              </Button>
            )}
          </div>
          {(waypoint.name_source || waypoint.description_source) && (
            <OriginalLanguageButton
              active={!isTranslated}
              handleClick={() => toggleIsTranslated(prevState => !prevState)}
              eventSource="Waypoint Popup"
            />
          )}
        </div>
      )}
    </div>
  );
};

WaypointPopup.propTypes = {
  toggleShowTitle: func,
  waypoint: waypointPropTypes.isRequired
};

WaypointPopup.defaultProps = {
  toggleShowTitle: null,
  messagingChannel: null
};

export default WaypointPopup;
